import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import type {
	AdjustBalancePayload,
	AssureYearlyBalancePayload,
	AssuredYearlyBalanceResponse,
	TransactionDetailResponse,
	TransactionIdData,
	TransactionOverviewData,
	TransactionOverviewSearchParams,
	UpdateBalanceInput,
} from "./types"

export const getTransactionDetails = (
	apiClient: APIClient,
	transactionId: string,
): Promise<TransactionDetailResponse> =>
	apiClient
		.get(`/transactions/${transactionId}/details`)
		.then(response => response.data)

export const adjustTransactionBalance = (
	apiClient: APIClient,
	transactionId: string,
	payload: AdjustBalancePayload,
): Promise<void> =>
	apiClient
		.post(
			`/transactions/${transactionId}/carbon-balance-adjustments`,
			payload,
		)
		.then(response => response.data)

export const getTransactionsData = (
	apiClient: APIClient,
	params: TransactionOverviewSearchParams,
): Promise<TransactionOverviewData> =>
	apiClient
		.get("/transactions", { params: { ...params } })
		.then(response => response.data)

export const updateBalance = (
	apiClient: APIClient,
	data: UpdateBalanceInput,
): Promise<string> =>
	apiClient.post("/transactions", data).then(response => response.data)

export const assureYearlyBalance = (
	apiClient: APIClient,
	payload: AssureYearlyBalancePayload,
): Promise<AssuredYearlyBalanceResponse> =>
	apiClient
		.put("/transactions", { params: { ...payload } })
		.then(response => response.data)

export const getTransactionIds = (
	apiClient: APIClient,
): Promise<TransactionIdData> =>
	apiClient
		.get("/transactions/transaction-ids")
		.then(response => response.data)
